import { Box, Button, Typography } from "@mui/material";
import { useState } from "react";
import { QrType } from "../types";
import { useDispatch } from "react-redux";
import { updateQrType } from "../../state/mainSlice";
import { useSelector } from "react-redux";
import { Root } from "../../state/types";
import { getIcon } from "./IconResolver";
import FormTeaser from "../TeaseSwitches/FormTeaser";
import LinkTreeTeaser from "../TeaseSwitches/LinkTreeTeaser";

const qrTypes = Object.values(QrType).map((value) => ({
    label: value.charAt(0).toUpperCase() + value.slice(1),
    value,
    icon: getIcon(value)
}));

const Selectors = () => {
    const dispatch = useDispatch();
    const typeSelector = useSelector((state: Root) => state.qrData.type);
    const [showFormTeaser, setShowFormTeaser] = useState(false);
    const [showLinktreeTeaser, setShowLinktreeTeaser] = useState(false);

    const handleTypeChange = (newType: QrType) => {
        if(newType === QrType.FORM){
            setShowFormTeaser(true);
        }else if (newType === QrType.LINK_TREE){
            setShowLinktreeTeaser(true);
        }else{
            dispatch(updateQrType(newType));
        }
    };

    return (
        <Box sx={{ marginBottom: 2, marginTop: 2 }}>
            <Typography variant="h6" gutterBottom>
                QR Code Type
            </Typography>
            <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
                {qrTypes.map(({ label, value, icon }) => (
                    <Button
                        key={value}
                        variant={typeSelector === value ? "contained" : "outlined"}
                        onClick={() => handleTypeChange(value)}
                        sx={{backgroundColor: '#000', textTransform: 'none', color: '#fff'}}
                        startIcon={icon}
                    >
                        {label}
                    </Button>
                ))}
            </Box>
            <FormTeaser show={showFormTeaser} hide={() => setShowFormTeaser(false)} />
            <LinkTreeTeaser show={showLinktreeTeaser} hide={() => setShowLinktreeTeaser(false)} />
        </Box>
    );
};

export default Selectors;
